/*
 * Real Drip — cart interactions
 * Feedback visual e acessibilidade sobre o MCart/quick-add existentes.
 */
(function () {
  'use strict';

  var live;

  function ensureLive() {
    if (live) return live;
    live = document.createElement('div');
    live.className = 'visually-hidden';
    live.setAttribute('aria-live', 'polite');
    live.setAttribute('role', 'status');
    document.body.appendChild(live);
    return live;
  }

  function announce(message) {
    var el = ensureLive();
    el.textContent = '';
    window.setTimeout(function () { el.textContent = message; }, 30);
  }

  function pulseCount() {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.classList.remove('is-pulsing');
      void el.offsetWidth;
      el.classList.add('is-pulsing');
    });
  }

  function haptic() {
    if (navigator.vibrate) navigator.vibrate(12);
  }

  function setup() {
    document.addEventListener('realdrip:cart:added', function (event) {
      pulseCount();
      haptic();
      if (event.detail && event.detail.label) announce(event.detail.label + ' adicionado ao carrinho');
    });

    document.addEventListener('click', function (event) {
      var quick = event.target.closest('[data-quick-add]');
      if (!quick || quick.disabled) return;

      quick.classList.add('is-pressed');
      window.setTimeout(function () { quick.classList.remove('is-pressed'); }, 140);

      document.addEventListener('realdrip:cart:added', function onAdded(e) {
        if (!e.detail || e.detail.source !== 'quick-add') return;
        pulseCount();
        haptic();
        document.removeEventListener('realdrip:cart:added', onAdded);
      }, { once: true });
    }, { passive: true });

    document.addEventListener('click', function (event) {
      var add = event.target.closest('[data-add-to-cart]');
      if (!add || add.disabled) return;
      add.classList.add('is-pressed');
      window.setTimeout(function () { add.classList.remove('is-pressed'); }, 140);
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
